module.exports = __webpack_public_path__ + "static/media/guitar.8835b546.jpeg";